/** Stable ids for the drawable surfaces that the space-bar lock can drive. */
export const SCRATCHPAD_SURFACE_ID = "scratchpad";
export const NOTEPAD_SURFACE_ID = "notepad";
export const SPACES_STUDENT_SURFACE_ID = "spaces-student";
export const SPACES_TEACHER_SURFACE_ID = "spaces-teacher";

/**
 * Marks the scratchpad's outer panel. Unlike the tldraw surfaces, whose
 * toolbar lives inside the editor container, the scratchpad's toolbar is a
 * sibling of its canvas — so the panel, not the canvas, is what owns its
 * controls. Spread onto the panel and matched from the canvas, from here, so
 * the two can never drift apart and silently un-own the toolbar.
 */
export const SCRATCHPAD_PANEL_ATTR = "data-scratchpad-panel";
export const SCRATCHPAD_PANEL_PROPS = { [SCRATCHPAD_PANEL_ATTR]: "" } as const;
export const SCRATCHPAD_PANEL_SELECTOR = `[${SCRATCHPAD_PANEL_ATTR}]`;
